import React, { ReactNode } from "react";
import Button from "antd/lib/button";
import { ThemeConfigKeys } from "../../utils/Constants";
import { ThemeProvider } from "../../layout/ThemeProvider";

interface IPrimaryButton {
  block?: boolean;
  disabled?: boolean;
  onClick?: any;
  className?: string;
  children: ReactNode | string;
  htmlType?: "button" | "submit" | "reset" | undefined;
}

const PrimaryButton: React.FC<IPrimaryButton> = (props) => {
  const {
    children,
    block,
    disabled = false,
    onClick,
    className,
    htmlType = "button",
  } = props;

  return (
    <ThemeProvider themeKey={ThemeConfigKeys.DefaultThemeSecondary}>
      <Button
        className={className}
        disabled={disabled}
        block={block}
        onClick={onClick}
        htmlType={htmlType}
        type="primary"
      >
        {children}
      </Button>
    </ThemeProvider>
  );
};

export default PrimaryButton;
